// ─────────────────────────────────────────────────────────────────────────────
// «Métricas unificadas» — la leyenda verde que la maqueta pone JUSTO DEBAJO de las 7 pestañas.
//
// El texto es el del prototipo, literal (`fundamentales-admin.js`, «Banner Homologación»): habla de
// Reco Diario y Brillamos Juntos por su nombre, no de «las siete pestañas». No es un matiz de estilo:
// lo que el banner afirma es que ESOS DOS módulos cuentan igual, que es la duda real del cliente —
// venían de dos reportes que daban cifras distintas. Generalizarlo a las siete diría algo más amplio
// de lo que se puede sostener.
//
// Va SIEMPRE, sin depender de permisos ni de la pestaña activa: describe cómo se calcula, no qué se
// ve. El aviso de auditoría, que sí depende de si puedes descargar, vive aparte en
// `BannersDeContexto`.
// ─────────────────────────────────────────────────────────────────────────────
import { useTranslation } from 'react-i18next';

export function BannerHomologacion() {
  const { t } = useTranslation('recognition');

  return (
    <p className="rr-homologacion">
      <i className="fas fa-check-circle" aria-hidden="true" />
      <span>
        <strong>{t('reports.context.unifiedTitle')}</strong> {t('reports.context.unifiedText')}
      </span>
    </p>
  );
}
